<app-slider #slider>
  <app-slider-view>
    <div content class="content text-center">
      @if (isaLinkInfo$ | async; as info){
      <h1>{{ info.eventName }}</h1>
      }
      <h2>{{ 'jobboard.views.standalone-isa.isa-views.welcome.title' | transloco }}</h2>
      <p class="mt-3" [innerHTML]="'jobboard.views.standalone-isa.isa-views.welcome.description' | transloco"></p>
    </div>
    <div actions>
      <button class="ct-btn ct-btn-themed-solid next" (click)="slider.next()">
        {{ 'jobboard.views.standalone-isa.start-button' | transloco }}
      </button>
    </div>
  </app-slider-view>
  <app-slider-view>
    <div content class="content">
      <form [formGroup]="isaForm">
        <app-skill-test #skillTest [control]="isaForm.get('isa')" [sliderAutoForward]="true" [showIntroQuestion]="true"
          [submitAttempt]="submitAttempt" class="px-1"></app-skill-test>
      </form>
      @if (skillTest.completed) {
      <p class="text-center mt-5">{{ 'jobboard.views.standalone-isa.isa-views.isa.completed' | transloco }}</p>
      }
    </div>
    <div actions>
      <button class="ct-btn ct-btn-themed prev" (click)="slider.prev()">
        {{ 'jobboard.views.standalone-isa.prev-button' | transloco }}
      </button>
      <button class="ct-btn ct-btn-themed-solid next" (click)="slider.next()" [disabled]="!skillTest.completed">
        {{ 'jobboard.views.standalone-isa.next-button' | transloco }}
      </button>
    </div>
  </app-slider-view>
  <app-slider-view>
    <div content class="content text-center">
      <h2>{{ 'jobboard.views.standalone-isa.isa-views.contact.title' | transloco }}</h2>
      <p class="mt-3">{{ 'jobboard.views.standalone-isa.isa-views.contact.description' | transloco }}</p>
      <form [formGroup]="contactForm" class="row px-1 mt-3">
        <div class="col-12 form-group form-floating"
          [class.invalid]="contactForm.get('firstName').invalid && submitAttempt">
          <input type="text" class="form-control" [formControl]="contactForm.get('firstName')" id="firstName"
            [placeholder]="'jobboard.views.apply.sections.general.form.inputs.first-name' | transloco"
            [autocomplete]="'off'" maxlength="30" />
          <label for="firstName">{{
            'jobboard.views.apply.sections.general.form.inputs.first-name' | transloco
            }}</label>
          <div class="validation">
            @if(contactForm.get('firstName').hasError('required')) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
            } @if (contactForm.get('firstName').hasError('pattern') &&
            !contactForm.get('firstName').hasError('required')) {
            <p>{{ 'ct-library.validation.pattern' | transloco }}</p>
            }
          </div>
        </div>
        <div class="col-12 form-group form-floating"
          [class.invalid]="contactForm.get('lastName').invalid && submitAttempt">
          <input type="text" class="form-control" [formControl]="contactForm.get('lastName')" id="lastName"
            [placeholder]="'jobboard.views.apply.sections.general.form.inputs.first-name' | transloco"
            [autocomplete]="'off'" maxlength="30" />
          <label for="lastName">{{ 'jobboard.views.apply.sections.general.form.inputs.last-name' | transloco }}</label>
          <div class="validation">
            @if(contactForm.get('lastName').hasError('required')) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
            } @if (contactForm.get('lastName').hasError('pattern') && !contactForm.get('lastName').hasError('required'))
            {
            <p>{{ 'ct-library.validation.pattern' | transloco }}</p>
            }
          </div>
        </div>
        <div class="col-12 form-group form-floating"
          [class.invalid]="contactForm.get('email').invalid && submitAttempt">
          <input type="email" class="form-control" [formControl]="contactForm.get('email')"
            [placeholder]="'jobboard.views.apply.sections.general.form.inputs.email' | transloco" [autocomplete]="'off'"
            maxlength="100" id="email" />
          <label for="email">{{ 'jobboard.views.apply.sections.general.form.inputs.email' | transloco }}</label>
          <div class="validation">
            @if (contactForm.get('email').hasError('required')) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
            } @if (contactForm.get('email').hasError('pattern') || contactForm.get('email').hasError('email')) {
            <p>{{ 'ct-library.validation.email' | transloco }}</p>
            }
          </div>
        </div>
        @if (privacyCheckboxEnabled){
        <div class="col-12 form-group terms-accept" [class.invalid]="!privacyAccepted && submitAttempt">
          <input type="checkbox" [(ngModel)]="privacyAccepted" [ngModelOptions]="{standalone: true}"
            id="privacyCheckbox" />
          <label for="privacyCheckbox">
            <p [innerHTML]="'jobboard.views.standalone-isa.isa-views.contact.checkboxes.privacy.short' | transloco"></p>
            @if(privacyCheckboxExpanded) {
            <p [innerHTML]="'jobboard.views.standalone-isa.isa-views.contact.checkboxes.privacy.long' | transloco"
              @collapseZoom></p>
            }
            <a (click)="$event.preventDefault(); privacyCheckboxExpanded = !privacyCheckboxExpanded">{{(privacyCheckboxExpanded
              ? 'jobboard.views.standalone-isa.isa-views.contact.checkboxes.show-less' :
              'jobboard.views.standalone-isa.isa-views.contact.checkboxes.show-more') | transloco}}</a>
          </label>
          <div class="validation">
            @if (!privacyAccepted) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
            }
          </div>
        </div>
        }
        @if (retargetingCheckboxEnabled){
        <div class="col-12 form-group terms-accept">
          <input type="checkbox" [(ngModel)]="allowRetargeting" [ngModelOptions]="{standalone: true}"
            id="retargetingCheckbox" />
          <label for="retargetingCheckbox">
            <p [innerHTML]="'jobboard.views.standalone-isa.isa-views.contact.checkboxes.retargeting.short' | transloco">
            </p>
            @if(retargetingCheckboxExpanded) {
            <p [innerHTML]="'jobboard.views.standalone-isa.isa-views.contact.checkboxes.retargeting.long' | transloco"
              @collapseZoom></p>
            }
            <a (click)="$event.preventDefault(); retargetingCheckboxExpanded = !retargetingCheckboxExpanded">{{(retargetingCheckboxExpanded
              ? 'jobboard.views.standalone-isa.isa-views.contact.checkboxes.show-less' :
              'jobboard.views.standalone-isa.isa-views.contact.checkboxes.show-more') | transloco}}</a>
          </label>
        </div>
        }
      </form>
    </div>
    <div actions>
      <button class="ct-btn ct-btn-themed prev" (click)="slider.prev()">
        {{ 'jobboard.views.standalone-isa.prev-button' | transloco }}
      </button>
      <button class="ct-btn ct-btn-themed-solid next" (click)="submit()"
        [tooltip]="(!privacyCheckboxEnabled || privacyAccepted) ? undefined : ('jobboard.views.standalone-isa.isa-views.contact.privacy-tooltip' | transloco)"
        [disabled]="(privacyCheckboxEnabled && !privacyAccepted) || submitting">
        {{ 'jobboard.views.standalone-isa.submit-button' | transloco }}
        @if (submitting) {
        <ct-lib-spinner class="ms-1 me-0" style="width: 20px"></ct-lib-spinner>
        }
      </button>
    </div>
  </app-slider-view>
  <app-slider-view>
    <div content class="content text-center">
      <img src="/assets/img/standalone-isa-success.svg" alt="" class="success-image" />
      <h2 class="mt-5 mb-2">{{ 'jobboard.views.standalone-isa.isa-views.success.title' | transloco }}</h2>
      <p class="mt-3" [innerHTML]="'jobboard.views.standalone-isa.isa-views.success.description' | transloco"></p>
      <p class="mt-3">{{ 'jobboard.views.standalone-isa.isa-views.success.linkedin' | transloco }}</p>
      <a class="linkedin" [href]="'https://www.linkedin.com/company/26198081'" target="_blank">
        <fa-icon [icon]="fontawesomeService.brands.linkedin" size="2x"></fa-icon>
      </a>
      <p class="mt-5">{{ 'jobboard.views.standalone-isa.isa-views.success.close-info' | transloco }}</p>
    </div>
  </app-slider-view>
</app-slider>